import { PolicyValidator, Policy, checkLicense, checkScope } from '../policy.interface';

export const scopes = {
    VIEW_ORDERS: 'vendor_stamp:VIEW_ORDERS',
    UPLOAD_DRAFT: 'vendor_stamp:UPLOAD_DRAFT',
    UPLOAD_STAMP: 'vendor_stamp:UPLOAD_STAMP',
};

const appPolicy = {
    validate: (policy: Policy) => {
        return checkLicense(policy, 'vendor_stamp');
    },
    ...Object.fromEntries(
        Object.entries(scopes).map(([key, value]) => [
            `can${key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join('')}`,
            (policy: Policy) => checkScope(policy, value)
        ])
    )
} as any; 

export default appPolicy;
